import type { S3FileWithUrl } from "~/types";

/** Must match propertyMgmtApiFunction `s3/lib.ts` RECEIPT_SIGNATURE_FILENAME. */
export const RECEIPT_SIGNATURE_FILENAME = "receipt-signature.png";

/** Finds the presigned URL for the user's receipt signature, if uploaded. */
export function findReceiptSignatureUrl(
  files: S3FileWithUrl[],
): string | null {
  const match = files.find((file) =>
    file.Key?.endsWith(`/${RECEIPT_SIGNATURE_FILENAME}`),
  );
  return match?.url ?? null;
}
